import get from 'lodash/get';

const env =
  get(window, 'env.ENV', '{{').slice(0, 2) === '{{' ? process.env : window.env;

export const ENV = env.ENV || env.NODE_ENV || 'development';

export const CLIENT_ID = env.REACT_APP_CLIENT_ID;

export const API_URL =
  env.REACT_APP_API_URL || 'https://api-example-for-testing.de';

export const OAUTH_URL =
  env.REACT_APP_OAUTH_URL || 'https://sandbox.identity.zalando.com';

export const SENTRY_DSN = env.REACT_APP_SENTRY_DSN;

export const UNLEASH_URL = env.REACT_APP_UNLEASH_URL;

export const UNLEASH_CLIENT_KEY = env.REACT_APP_UNLEASH_CLIENT_KEY;

export const UNLEASH_ENABLED = env.REACT_APP_UNLEASH_ENABLED === 'true';

// The VERSION does not change based on the environment. It can be inserted at build time.
export const VERSION = process.env.REACT_APP_VERSION;

export const isProduction = () => ENV.toLowerCase() === 'production';

export const isDevelopment = () => ENV.toLowerCase() === 'development';

export const isE2E = () => ENV.toLowerCase() === 'e2e-test';
